import './error-page.css';
import { Alert, AlertTitle } from '@mui/material';
import { Link } from 'react-router-dom';

const ErrorPage = (props) => {
    return (
        
            <div className="d-flex justify-content-center extra-margin-top ">
                <Alert severity="error" className='container'>
                    <AlertTitle id="access-text">{props.msg ? props.msg : 'Internal Server Error'} !</AlertTitle>
                    <Link to='/' ><strong className='link pointer text-primary' id="access-text">back!</strong></Link>
                </Alert>
            </div>
        
    )
}

export default ErrorPage;